import { ExperimentStore } from 'bernie-plugin-mobx';

import { ILocalization } from '@shared-ui/localization-context';

export class SearchValidation {
  private _formatText: ILocalization['formatText'];
  private _experiment: ExperimentStore | undefined;

  constructor(formatText: ILocalization['formatText'], experiment?: ExperimentStore) {
    this._formatText = formatText;
    this._experiment = experiment;

    this.adults = this.adults.bind(this);
    this.children = this.children.bind(this);
    this.destination = this.destination.bind(this);
    this.endDate = this.endDate.bind(this);
    this.formatText = this.formatText.bind(this);
    this.isValidDate = this.isValidDate.bind(this);
    this.startDate = this.startDate.bind(this);
  }

  public adults({ adults }: { adults?: string }) {
    if (!adults || parseInt(adults, 10) <= 0) {
      return this.formatText('hotels.search.validation.invalidGuests.text');
    }
  }

  public children({ children }: { children?: string }) {
    if (!children) {
      return;
    }

    const { formatText } = this;

    const childAges = children.split(',');

    const message =
      childAges.length === 1
        ? formatText('hotels.search.validation.missingChildAge.text')
        : formatText('hotels.search.validation.missingChildrenAges.text');

    let error = false;

    childAges.forEach(child => {
      if (!child.match(/\d{1,2}_\d{1,2}/)) {
        // i.e. roomNumber_childAge, e.g. 1_4
        error = true;
      }
    });

    return error ? message : undefined;
  }

  public destination({ destination }: { destination?: string }) {
    if (!destination) {
      return this.formatText('hotels.search.validation.invalidDestination.text');
    }
  }

  public endDate({ startDate, endDate }: { startDate?: string; endDate?: string }) {
    const { isValidDate, formatText } = this;

    const start = startDate ? new Date(startDate) : undefined;
    const end = endDate ? new Date(endDate) : undefined;

    if (!isValidDate(end)) {
      return formatText('hotels.search.validation.invalidToDate.text');
    }

    if (start && end && isValidDate(start)) {
      const maxEndDate =
        this.isVrbex() && this.isVrbex28PlusDayStay() ? null : new Date(start.getFullYear(), start.getMonth(), start.getDate() + 28);

      if (end < start) {
        return formatText('hotels.search.validation.invalidDateRange.text');
      }

      if (maxEndDate) {
        maxEndDate.setHours(0, 0, 0, 0);
      }

      end.setHours(0, 0, 0, 0);

      if (maxEndDate !== null && end > maxEndDate) {
        return formatText('hotels.search.validation.invalidDateDateRangeLength.text');
      }
    }
  }

  public formatText(key: string) {
    return this._formatText(key);
  }

  public isValidDate(date?: Date) {
    return date && date.toString() !== 'Invalid Date';
  }

  public startDate({ startDate }: { startDate?: string }) {
    const { isValidDate, formatText } = this;

    const start = startDate?.length ? new Date(startDate) : undefined;

    if (!isValidDate(start)) {
      return formatText('hotels.search.validation.invalidFromDate.text');
    }
  }

  private isVrbex() {
    return this._experiment?.exposures?.Vrbex_generic?.bucket === 1;
  }

  private isVrbex28PlusDayStay() {
    return this._experiment?.exposures?.vrbex_28_plus_day_stays?.bucket === 1;
  }
}
